import { render, staticRenderFns } from "./balance-reports.vue?vue&type=template&id=43a82bb9&scoped=true"
import script from "./balance-reports.vue?vue&type=script&lang=js"
export * from "./balance-reports.vue?vue&type=script&lang=js"
import style0 from "./balance-reports.vue?vue&type=style&index=0&id=43a82bb9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a82bb9",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/curacao/balance-reports.vue
// module id = 13aH
// module chunks = 0